import { Component, Input, OnInit, OnDestroy } from '@angular/core'
import { Subscription } from 'rxjs'

@Component({
  selector: 'app-table-scheduled-with-display',
  templateUrl: './table-scheduled-with-display.component.html',
  providers: []
})

export class TableScheduledWithDisplayComponent implements OnInit, OnDestroy {

  /**
   * Telephones
   */
  @Input() scheduledWith: any

  /**
   * Display
   */
  public display: boolean

  /**
   * Subscriptions
   */
  private subscriptions: Array<Subscription> = []

  /**
   * First item
   */
  public firstItem: any

  /**
   * Constructor
   */
  public constructor () {}

  /**
   * Ng on init
   */
  public ngOnInit (): void {
    this.display = false
    if (this.scheduledWith && this.scheduledWith.length > 0) {
      // this.with.sort((a, b) => a.telephoneName.displayOrder - b.telephoneName.displayOrder)
      // this.firstItem = this.with.find((x) => x.telephoneNameUuid === this.telephoneNameUuid)

      if (!this.firstItem) {
        this.firstItem = this.scheduledWith[0]
      }

      this.display = true
    }
  }

  /**
   * On destroy
   */
  public ngOnDestroy (): void {
    this.subscriptions.forEach((subscription) => {
      subscription.unsubscribe()
    })
  }

}
